export const publicRoutes = {
  globalAuth: `${process.env.REACT_APP_AUTHENTICATION_SERVICE_URL}`,
  globalAuthSignIn: `${process.env.REACT_APP_AUTHENTICATION_SERVICE_URL}/sign-in`,
  signIn: '/sign-in',
  acceptInvitation: 'auth/invite/:invitationId',
  onboarding: '/onboarding/*',
};

export const privateRoutes = {
  home: '/',

  claims: '/claims',
  claimSubmissions: '/claims/submissions',
  claimEClaimLink: '/claims/eclaimlink',
  claimRiayati: '/claims/riayati',
  claimShafafiya: '/claims/shafafiya',
  claimDetails: '/claims/details/:claimId',
  claimSubmissionForm: '/claims/submissions/form/:submissionId',
  claimCreateSubmissionForm: '/claims/submissions/form',
  claimCreateDraftResubmissionForm: '/claims/submissions/resubmission/:claimId',

  dashboard: '/dashboard',
  dashboardOverview: '/dashboard/overview',
  dashboardClinicians: '/dashboard/clinicians',
  dashboardCollections: '/dashboard/collections',
  dashboardAgeing: '/dashboard/ageing',
  dashboardPayments: '/dashboard/payments',
  dashboardRejections: '/dashboard/rejections',

  branchForm: '/settings/branch-management/edit/:branchId',
  branchAddForm: '/settings/branch-management/add',
  branchList: '/settings/branch-management',

  userForm: '/settings/user-management/edit/:userId',
  userAddForm: '/settings/user-management/add',
  userList: '/settings/user-management',

  loginAs: '/settings/login-as',

  report: '/report',
};
